import cx from 'classnames';
import Img from 'mk2/components/Img';
import NotificationsBadge from 'mk2/components/NotificationsBadge';
import { FeedItem, MenuItem } from 'mk2/containers/PageHeader/PageHeader.reducers';
import { CompatibleLink } from 'mk2/containers/SiteMenu/SiteMenu';
import React from 'react';
import styles from './GroupsMenu.mscss';

interface OwnProps {
    className?: string;
    feedMenu: MenuItem[];
    currentUrl: string;
    fluxibleCompatibility: boolean;
    mergedForumAndGroups?: boolean;
    mobile: boolean;
    requestUserPermissions?: string[];
    section?: string;
}

type Props = OwnProps;

const GroupsMenu: React.FunctionComponent<Props> = ({ className, feedMenu, currentUrl, fluxibleCompatibility, mergedForumAndGroups, mobile, requestUserPermissions, section }) => {
    const isBlogsAdmin = requestUserPermissions && requestUserPermissions.indexOf('photoblog.can_manage_blogs') >= 0;
    const isForumAdmin = requestUserPermissions && requestUserPermissions.indexOf('forum.can_manage_forum') >= 0;

    const flagged = isBlogsAdmin && mergedForumAndGroups && mobile && feedMenu.find((item) => item.name === 'flagged');
    const flaggedGroups = isForumAdmin && mergedForumAndGroups && feedMenu.find((item) => item.name === 'flagged-groups');

    return (
        <div className={cx(styles.GroupsMenu, className)}>
            {flagged &&
                <Item item={flagged} selected={flagged.url === currentUrl} fluxibleCompatibility={fluxibleCompatibility} />}

            {flaggedGroups &&
                <Item item={flaggedGroups} selected={flaggedGroups.url === currentUrl} fluxibleCompatibility={fluxibleCompatibility} />}

            {feedMenu.map((item) => (
                (item.isGroup) ? (
                    ((mergedForumAndGroups && item.mergedForumGroups !== false && (item.section === null || item.section === section)) || (!mergedForumAndGroups && item.mergedForumGroups !== true)) &&
                    (item.items.length) > 0 && (
                        <div key={item.title}>
                            <h2 className={styles.GroupsMenu__title}>
                                {item.icon ? (
                                    item.icon.startsWith('fa')
                                        ? <i
                                            className={cx(
                                            'fa',
                                                item.icon,
                                                styles.GroupsMenu__link__icon,
                                                {
                                                    [styles['GroupsMenu__link__icon--fa-star']]: item.icon === 'fa-star',
                                                },
                                            )}
                                        />
                                        : null
                                ) : null}
                                {item.title}
                            </h2>
                            {item.items.map((groupItem) => (
                                <Item key={groupItem.name} item={groupItem} selected={currentUrl.startsWith(groupItem.url)} fluxibleCompatibility={fluxibleCompatibility} newIcons={mergedForumAndGroups} />
                            ))}
                        </div>
                    )
                ) : (
                    ((mergedForumAndGroups && item.mergedForumGroups !== false && (item.section === null || item.section === section)) || (!mergedForumAndGroups && item.mergedForumGroups !== true)) &&
                        <Item key={item.title} item={item} selected={item.url === currentUrl || item.url2 === currentUrl || item.url3 === currentUrl} fluxibleCompatibility={fluxibleCompatibility} />
                )
            ))}
        </div>
    );
};

GroupsMenu.displayName = 'GroupsMenu';

export default GroupsMenu;

interface MenuItemOwnProps {
    fluxibleCompatibility: boolean;
    item: FeedItem;
    newIcons?: boolean;
    selected: boolean;
}

// TODO: Replace with <Link> when everything will be in react-redux (currently this cannot be used in market)
const Item: React.FunctionComponent<MenuItemOwnProps> = ({ fluxibleCompatibility, item, newIcons, selected }) => (
    <CompatibleLink
        className={cx(styles.GroupsMenu__link, (item.title === 'Flagged') ? styles['GroupsMenu__link--flagged'] : null, selected && styles['GroupsMenu__link--selected'], 'topmenu-mobilemenuGroupLink')}
        fluxibleCompatibility={fluxibleCompatibility}
        to={item.url}
    >
        {item.icon ? (
            item.icon.startsWith('fa')
                ? <i className={cx('fa', item.icon, styles.GroupsMenu__link__icon)} />
                : (newIcons ? (
                        <Img className={styles.GroupsMenu__link__newIconImg} src={item.icon} width={18} height={16} />
                    ) : (
                        <Img className={styles.GroupsMenu__link__oldIconImg} src={item.icon} width={16} height={13} />)
                )
        ) : null}
        <span>{item.title}</span>
        <NotificationsBadge className={styles.GroupsMenu__notificationsBadge} count={item.lastVisitCount} />
    </CompatibleLink>
);
